import type { HelpFile } from '../../types/help'
import { AccessAnalyticsDashboardTestIds } from '../../../testids/AccessAnalyticsDashboardTestIds'

export const accessAnalyticsDashboardHelp: HelpFile = {
  docPage: '/docs/analytics/access-analytics',
  texts: {
    [AccessAnalyticsDashboardTestIds.accessAnalyticsDashboardPage]:
      'Overview of effective access across the organization — identifies the identities and target systems with the most granted access.',
    [AccessAnalyticsDashboardTestIds.cardTitleTopIdentities]:
      'Identities ranked by the number of effective access grants they currently hold.',
    [AccessAnalyticsDashboardTestIds.cardTitleTopSystems]:
      'Target systems ranked by the number of effective access grants currently issued against them.',
    [AccessAnalyticsDashboardTestIds.colGrants]:
      'Number of effective access grants — sums all entitlements derived from direct assignments, role memberships, and rule-based access.',
    [AccessAnalyticsDashboardTestIds.colIdentity]:
      'Identity holding the effective access grants.',
    [AccessAnalyticsDashboardTestIds.colSystem]:
      'Target system on which the grants are issued.',
    [AccessAnalyticsDashboardTestIds.filterPeriod]:
      'Limit the analysis to grants effective within a chosen time window.',
    [AccessAnalyticsDashboardTestIds.inputAnalyticsFrom]:
      'Start of the custom time window — only grants effective from this moment onward are included.',
    [AccessAnalyticsDashboardTestIds.inputAnalyticsTo]:
      'End of the custom time window — only grants effective up to this moment are included.',
    [AccessAnalyticsDashboardTestIds.linkIdentitiesWithGrants]:
      'Open the full list of identities and their effective access grants.',
    [AccessAnalyticsDashboardTestIds.linkTargetSystems]:
      'Open the target systems list to drill down into a system\u2019s grants.',
  },
}
